module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_3.25f62c84.jpg";